import React, { Suspense, lazy } from "react";
import Loading from "./components/layout/Loading";

const LazyMain = lazy(()=>import('./components/Main'))

function App() {
  return (
    <Suspense fallback={<Loading/>}>
      <LazyMain/>
    </Suspense>
  );
}

export default App;
